import { render, staticRenderFns } from "./CVendorMulti.vue?vue&type=template&id=3740d4c4"
import script from "./CVendorMulti.vue?vue&type=script&lang=js"
export * from "./CVendorMulti.vue?vue&type=script&lang=js"
import style0 from "./CVendorMulti.vue?vue&type=style&index=0&id=3740d4c4&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3740d4c4')) {
      api.createRecord('3740d4c4', component.options)
    } else {
      api.reload('3740d4c4', component.options)
    }
    module.hot.accept("./CVendorMulti.vue?vue&type=template&id=3740d4c4", function () {
      api.rerender('3740d4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CVendorMulti.vue"
export default component.exports